import { render } from "./VideoCp.vue?vue&type=template&id=bd36440a&scoped=true"
import script from "./VideoCp.vue?vue&type=script&lang=js"
export * from "./VideoCp.vue?vue&type=script&lang=js"

import "./VideoCp.vue?vue&type=style&index=0&id=bd36440a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd36440a"]])

export default __exports__